
import { Component, Mixins, Prop, VModel } from "vue-property-decorator";
import { authentication } from "@pazion/pazion-core/src/store";
import {
  getMarketplaces,
  getOrderAttributes,
  getOrderDetails,
  getProductAccountPrice,
  getProductType,
  updateOrder,
  updateOrderLine,
  getOrderStatuses,
  getCustomOrderLines,
  addCustomOrderLine,
  deleteCustomOrderList,
  getProductCategories,
  getProductOrientations,
  getProductExtras,
} from "../../services/catalog-service";
import { formatDateTime } from "@pazion/pazion-core/src/services/base-service";
import PazLoader from "@pazion/pazion-core/src/components/utils/PazLoader.vue";
//import OrderCustomerTab from "./tabs/OrderCustomerTab.vue";
import FulfilmentTab from "./tabs/FulfilmentTab.vue";
import CustomOrderLineTab from "./tabs/CustomOrderLineTab.vue";
import AttributesTab from "./tabs/AttributesTab.vue";
import { formatDate, formatDateYMD } from "../../helpers/format";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import OrderItemsTab from "./tabs/OrderItemsTab.vue";
import PazOrderMappedStatus from "@pazion/pazion-catalog/src/components/order/_common/PazOrderMapedStatuses.vue";
import PazConfirmation from "@pazion/pazion-core/src/components/utils/PazConfirmation.vue";
import PazDateField from "@pazion/pazion-core/src/components/utils/PazDateField.vue";
import PazAdressPicker from "../picker/PazAdressPicker.vue";
import CustomerPicker from "../picker/CustomerPicker.vue";
import {
  IOrderAttributeName,
  ICustomOrderLine,
  IOrderOne,
} from "../../models/order";
import { IMarketplace } from "../../models/base";
import PazOrderAttributesDialog from "./PazOrderAttributeDialog.vue";
import { PatchPricing } from "./mixins/patchPricingMixin";
import { IproductTypesModel } from "../../models/product";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";
import { fieldsByClass } from "@pazion/pazion-core/src/services/settings-fields";

@Component({
  components: {
    PazLoader,
    OrderItemsTab,
    //OrderCustomerTab,
    FulfilmentTab,
    AttributesTab,
    PazOrderMappedStatus,
    CustomerPicker,
    PazTooltipButton,
    PazConfirmation,
    PazDateField,
    PazAdressPicker,
    PazOrderAttributesDialog,
    CustomOrderLineTab,
  },
  methods: {
    formatDate,
    formatDateTime,
    formatDateYMD,
    fieldsByClass,
  },
})
export default class PazOrderDialog extends Mixins(
  PatchPricing,
  PermissionService
) {
  $refs!: {
    confirm: PazConfirmation;
  };

  @VModel({
    default: false,
  })
  public showDialog!: boolean;

  @Prop({ default: false })
  public isShapemakers!: boolean;

  @Prop({ default: true }) public editAble!: boolean;
  @Prop({ default: true }) public canOrderEditableWithStatus: boolean;
  @Prop({ default: 0 }) public orderId!: number;
  @Prop() public showProductionBtn?: boolean;
  @Prop() public fromFulfilment: boolean;
  @Prop({ default: () => [] })
  public tenantOptionsList!: { title: string; value: number }[];

  @Prop({ default: false })
  public isShowTenant!: boolean;

  @Prop({ default: null })
  public tenantData?: number | null;

  public tenant: number | null = null;
  public orderDate: string = "";
  public preferredDeliveryDate: string = "";
  public loading: boolean = false;
  public orderData = {} as IOrderOne;
  public showCustomerPicker: boolean = false;
  public showAdressPicker: boolean = false;
  public orderNotes: string = "";
  public selectedOrderStatus: string = "";
  public orderAttributeNames: IOrderAttributeName[] = [];
  public marketplaces: IMarketplace[] = [];
  public currentAddressType: number = 0;
  public currentAddrPickedId: number | null = null;
  public showAttributesModal: boolean = false;
  public productTypes: IproductTypesModel[] | [] = [];
  public orderStatuses = {};
  private orderFormModel: boolean = false;
  public isCustomOrders: boolean = false;
  public isAddNewOrderLine: boolean = false;
  public customOrderLineList: ICustomOrderLine[] = [];
  public productCategories: { title: string; value: string }[] = [];
  public productOrientations: { title: string; value: string }[] = [];
  public productExtras: { title: string; value: string }[] = [];

  async updateData() {
    await this.fetchData(false);
    this.$emit("order:update");
  }

  get isUserAdmin() {
    return authentication?.getProfile?.roles?.includes("administrator");
  }

  get canPickCustomer() : boolean{
    return this.hasProfileFlag('orderManagement.edit.customer');
  }

  async doDuplicateOrder() {
    const orderId = this.orderId;
    const confirm = await this.$refs.confirm.openConfirmDialog(
      "Duplicate",
      "Are you sure you want to duplicate order  `" + orderId + "`?"
    );
    if (confirm) {
      this.showDialog = false;
      this.$emit("duplicate-order", orderId);
    }
  }

  async fetchData(withLoading?: boolean) {
    if (withLoading == undefined || withLoading) this.loading = true;
    [
      this.orderData,
      this.orderStatuses,
      this.orderAttributeNames,
      this.marketplaces,
      this.productTypes,
    ] = await Promise.all([
      getOrderDetails(this.orderId, this.$productionManagement),
      getOrderStatuses(),
      getOrderAttributes(),
      getMarketplaces(),
      getProductType(),
    ]);

    this.tenant = this.orderData.order.tenant;

    if (this.isShapemakers) {
      this.customOrderLineList = await getCustomOrderLines({
        order: this.orderData.id,
      });
      await this.fetchProductData();
    }

    this.orderNotes = this.orderData?.notes;
    this.orderDate = formatDateTime(
      this.orderData?.order?.orderDate,
      undefined,
      "YYYY-MM-DD",
      false
    );

    this.preferredDeliveryDate = formatDateTime(
      this.orderData.order.preferredDeliveryDate,
      undefined,
      "YYYY-MM-DD",
      false
    );

    this.loading = false;
    this.fromFulfilment && document.getElementById("deliveryTab")?.click();
  }

  productionAction() {
    this.$emit("onShowOrderProduction", this.orderData?.order);
    this.showDialog = false;
  }

  openAddressPicker(addresttType: number, pickedId?: number) {
    this.showAdressPicker = true;
    this.currentAddressType = addresttType;
    this.currentAddrPickedId = pickedId;
  }

  //NOTE: Check permissions for status

  get canChangeStatus() {
    return this.hasProfileFlag("orderManagement.edit.status");
  }

  // STUB: order statuses
  get cOrderStatuses(): any[] {
    let statusOfSelectedOrder: string = this.orderData.order.status;

    if (!statusOfSelectedOrder) {
      return [];
    }

    let selectableStatuses: string[] =
      this.orderStatuses.orderStatuses[statusOfSelectedOrder];

    if (
      selectableStatuses &&
      selectableStatuses.length !== 0 &&
      !selectableStatuses.includes(statusOfSelectedOrder)
    )
      selectableStatuses.push(statusOfSelectedOrder);

    if (!this.hasStatusPermission) {
      /**
       * NOTE: PERM
       * check canChangeStatus if false add opportunity
       * to change DRAFT to NEW/READY_TO_INVOICE
       * */
      selectableStatuses = selectableStatuses.filter(
        (st) => st && ["NEW", "DRAFT", "READY_TO_INVOICE"].includes(st)
      );
    }

    if (!this.selectedOrderStatus)
      this.selectedOrderStatus = statusOfSelectedOrder;

    if (Array.isArray(selectableStatuses)) {
      return selectableStatuses.map((status: string) => {
        return { status, label: status.replaceAll("_", " ") };
      });
    }
    return [];
  }

  get hasStatusPermission() {
    return this.hasProfileFlag("orderManagement.edit.status");
  }

  get hasDelivery(): boolean {
    return (
      this.orderData?.fulfilments?.length > 0 &&
      this.orderData?.fulfilmentOrderLines?.length > 0
    );
  }

  get hasAttributes(): boolean {
    return this.orderData?.orderAttributes?.length > 0;
  }

  get getOrderStatus(): string {
    return this.orderData?.order?.status || "";
  }

  get getOrderType(): string {
    return this.orderData?.order?.orderType || "";
  }

  get getOrderDataContact() {
    return this.orderData.order?.customer.business
      ? this.orderData.order?.customer.business +
          " - " +
          this.orderData.order?.customer.contact
      : this.orderData.order?.customer.contact;
  }

  get getContactName() {
    return this.orderData.order?.customer.business;
  }
  get getFormattedOrderDataShippingAddress() {
    return this.getOrderDataShippingAddress.replaceAll(",", "<br/>");
  }
  get getOrderDataShippingAddress() {
    const currentAddress =
      this.orderData.order?.shippingaddress?.hasOwnProperty("id") &&
      this.orderData.order?.shippingaddress;
    return currentAddress
      ? `${!this.$onlyShowCompany ? currentAddress.name + ", " : ""} ${
          currentAddress.street
        } ${currentAddress.houseNumber}, ${currentAddress.zipcode} ${
          currentAddress.city
        }`
      : "";
  }

  get getFormattedOrderDataBillingAddress() {
    return this.getOrderDataBillingAddress.replaceAll(",", "<br/>");
  }
  get getOrderDataBillingAddress() {
    const currentAddress =
      this.orderData.order?.billingaddress?.hasOwnProperty("id") &&
      this.orderData.order?.billingaddress;
    return currentAddress
      ? `${!this.$onlyShowCompany ? currentAddress.name + ", " : ""} ${
          currentAddress.street
        } ${currentAddress.houseNumber}, ${currentAddress.zipcode} ${
          currentAddress.city
        }`
      : "";
  }

  async updateOrderStatus(value: string) {
    const res = await this.updateOrderByField("status", value, true);
    if (res && res.success) {
      await this.updateData();
    }
  }

  async updateOrderByField(
    key: string,
    value: string | number,
    novalidate?: boolean
  ) {
    let valid = true;
    if (!novalidate) {
      this.$refs[key].validate();
      valid = this.$refs[key] && this.$refs[key].valid;
    }
    if (valid) {
      const res = await updateOrder(this.orderData.id, { [key]: value });
      if (!res || !res.success) {
        const errorMessage =
          res?.response?.data?.detail || `${key} hasn't been changed!`;
        this.$parent.$refs.toast.show({
          message: errorMessage,
          icon: "mdi-close-circle",

          color: "red",
        });
        return;
      }
      return res;
    }
  }

  nv(field: string, v: any) {
    return (
      (this.fieldsByClass(this, field).required ? !!v : true) ||
      `${this.fieldsByClass(this, field).label} is required`
    );
  }

  async updateAccount(accountId: number) {
    const response = await updateOrder(this.orderData.id, {
      accountId: accountId,
    });
    if (response && response.success) {
      if (this.$pricelistManagement && this.orderData.orderlines.length > 0) {
        this.orderData.orderlines.forEach(async (line, index) => {
          const spPrice = await getProductAccountPrice({
            filter: JSON.stringify({
              operator: "AND",
              product_catalog_pricelist_account__account_id: accountId,
              product_catalog_product_pricelist__product_id: line?.product?.id,
            }),
          });
          if (spPrice && spPrice.length && spPrice.length > 0) {
            const spObjectPrice =
              spPrice.shift().product_catalog_product_pricelist__price;
            const sPrice = this.patchCalculatedPrice(
              parseFloat(spObjectPrice),
              line
            );
            const res = await updateOrderLine(line.id, { price: sPrice });
            if (res && index + 1 === this.orderData.orderlines.length) {
              this.fetchData();
            }
          } else {
            if (index + 1 === this.orderData.orderlines.length) {
              this.fetchData();
            }
          }
        });
      } else {
        this.fetchData();
      }
    }
  }

  async updateAddress(adressId: number) {
    let addressTypeField = {};
    if (this.currentAddressType === 1)
      addressTypeField = { shippingAddressId: adressId };
    else if (this.currentAddressType === 2)
      addressTypeField = { billingAddressId: adressId };
    await updateOrder(this.orderData.id, addressTypeField);
    this.fetchData();
  }

  async addAttributeToOrder(data: {
    instance: string;
    nameTech: string;
    value: string;
  }) {
    this.loading = true;
    await updateOrder(this.orderData.id, { attribute: data });
    this.fetchData();
    this.$emit("order:update");
    this.loading = false;
  }

  openCustomerPicker() {
    if (!this.canOrderEditableWithStatus) {
      return;
    }
    this.showCustomerPicker = true;
  }

  //  async updateShippingAdress(adressId: number) {
  //   await updateOrder(this.orderDetailsData.id, {shippingAddressId: adressId});
  //   this.$emit('update-data');
  // }

  // NOTE: Mutate Prefered delivery date
  async onDeliveryPreferedChange(date: Date) {
    if (date) {
      const res = await updateOrder(this.orderData.id, {
        preferredDeliveryDate: date,
      });
      if (!res || !res.success) {
        this.$parent.$refs.toast.show({
          message: "Preferred delivery date hasn't been changed!",
          icon: "mdi-close-circle",

          color: "red",
        });
        return;
      }
      this.$emit("order:update");
    }
  }

  get canCopyOrder() {
    //@ts-ignore
    return this.$copyOrder != undefined && this.$copyOrder;
  }

  get canEditOrderLineStatus() {
    //@ts-ignore
    return this.$editOrderLineStatus != undefined && this.$editOrderLineStatus;
  }

  get orderHasProduction() {
    //@ts-ignore
    return !this.orderData?.production?.length > 0;
  }

  get getOrderAttributesCount() {
    return this.orderData?.orderAttributes?.length;
  }

  get isOwnMarketplace() {
    if (this.orderData && this.orderData.hasOwnProperty("order")) {
      if (!this.orderData.order.marketplace) return false;
      const currentMarketplace = this.marketplaces.find(
        (m) => m && m.id === this.orderData.order.marketplace
      );
      if (currentMarketplace && currentMarketplace.hasOwnProperty("nameTech")) {
        return currentMarketplace.nameTech === "order2flow";
      }
    }
    return false;
  }

  async handleAddCustomOrderLine(data: ICustomOrderLine) {
    const params = { ...data, order: this.orderData.id };
    await addCustomOrderLine(params);
    this.customOrderLineList = await getCustomOrderLines({
      order: this.orderData.id,
    });
    this.isAddNewOrderLine = false;
  }

  async handleRemoveCustomOrderLine(id: number) {
    await deleteCustomOrderList(id);
    this.customOrderLineList = await getCustomOrderLines({
      order: this.orderData.id,
    });
  }

  async fetchProductData() {
    const [productCategories, productOrientations, productExtras] =
      await Promise.all([
        getProductCategories(),
        getProductOrientations(),
        getProductExtras(),
      ]);
    this.productCategories = Object.entries(productCategories.data).map(
      (entry: any ) => {
        return { title: entry[1], value: entry[0] };
      }
    );
    this.productOrientations = Object.entries(productOrientations.data).map(
      (entry: string[]) => {
        return { title: entry[1], value: entry[0] };
      }
    );
    this.productExtras = Object.entries(productExtras.data).map(
      (entry: string[]) => {
        return { title: entry[1], value: entry[0] };
      }
    );
  }

  async handleUpdateTenant(id: number) {
    await updateOrder(this.orderData.id, { tenant: id });
  }

  public productType: string = "";

  handleCreateOrderLine(type: string) {
    this.productType = type;
    this.isAddNewOrderLine = true;
  }

  async mounted() {
    if (this.isShapemakers) {
      this.isCustomOrders = true;
    }
    this.fetchData();
  }
} //
